import React, {CSSProperties, Dispatch, useCallback} from "react";
import {Col, Icon, Layout, Modal, Row, Spin} from "antd";
import Phase2Table from "../table";
import useBreakpoints from "../../../../../hooks/useBreakpoints";
import {Phase2Api} from "../api";
import {State} from "../state";
import {overrideTableApi} from "./api-override";
import Toolbar from "../toolbar";
import {BASE_CLS, isFlightScheduled} from "../util";
import '../phase-2-scheduler.less';
import {ColumnProps} from "antd/lib/table";
import {isTruey} from "../../../../../common/util-ts";
import {uniqBy} from "lodash";
import {getSNodeID} from "../../../../../components/scheduling/util";
import pluralize from "pluralize";

const { Content } = Layout;

export interface ScheduledToExpectedPaxCgoToolProps {
    state: State,
    api: Phase2Api
}

const ScheduledToExpectedPaxCgoTool: React.FC<ScheduledToExpectedPaxCgoToolProps> = (props) => {

    const { state, api } = props;
    const bp = useBreakpoints();

    const apiOverride = useCallback(() => overrideTableApi(state, api), [ state, api ])();

    const selectedEntities = state.scheduledToExpectedPaxCgo.data.entities
        .filter((entity) => (
            state.scheduledToExpectedPaxCgo.selection.selectedEntityIds
                .includes(getSNodeID(api.toScheduleNode(entity)))
        ));

    return <Modal
        title="Convert PAX/CGO to Expected"
        visible={state.scheduledToExpectedPaxCgo.modal.open}
        width={bp.min("large") ? 1300 : '100%'}
        bodyStyle={{ maxHeight: 800, overflowY: 'auto', overflowX: 'hidden', padding: 0 }}
        onCancel={() => api.scheduledToExpectedPaxCgo.modal.setOpen(false)}
        okButtonProps={{
            type: 'danger',
            disabled: !selectedEntities.length,
            loading: api.scheduledToExpectedPaxCgo.isLoading
        }}
        okText={`Change ${selectedEntities.length} PAX/CGO to Expected`}
        onOk={api.scheduledToExpectedPaxCgo.start}
    >
        <Layout className={BASE_CLS + '-layout'}>
            <Toolbar api={apiOverride} featureConfig={{
                viewMenu: {
                    enabled: true
                },
                selectMenu: {
                    enabled: true,
                    forceVisible: true
                },
                selectionCount: {
                    enabled: true
                }
            }} />
            <Content className={BASE_CLS + '-layout-content'} style={{ padding: 12 }}>
                <Spin
                    className="ant-spin-fill-height"
                    indicator={<Icon type="loading" style={{ fontSize: '3rem' }} />}
                    spinning={false}
                >
                    <Phase2Table
                        api={apiOverride}
                        disableEditing
                        allowSelection
                    />
                </Spin>
            </Content>
        </Layout>
    </Modal>
}

export default ScheduledToExpectedPaxCgoTool;